import { useContext, useEffect, useState } from 'react'
import { ModalContext } from '@nv/contexts'
import { UploadDocs } from '@nv/pages'
import { AdminVoterService } from '@nv/services'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const UploadID = ({ voterId, onDone, isOpen }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const [doClear, setDoClear] = useState(false)

  const serializeFile = (file) => {
    if (!file) return null

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        resolve({
          name: file.name,
          type: file.type,
          size: file.size,
          content: reader.result,
        })
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  const validationSchema = Yup.object({
    proofOfIdentity: Yup.string().required('proofOfIdentity is required'),
  })

  const initialValues = {
    proofOfIdentity: null,
    supportedDocument: null,
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const serializedFiles = await Promise.all([serializeFile(values.proofOfIdentity)])

      const serializedValues = {
        ...values,
        photoIDs: serializedFiles.filter(Boolean),
      }

      const formData = new FormData()
      const photoFiles = serializedValues.photoIDs.map((photo) => {
        //@ts-ignore
        const byteCharacters = atob(photo.content.split(',')[1])
        const byteArrays = []
        for (let offset = 0; offset < byteCharacters.length; offset++) {
          byteArrays.push(byteCharacters.charCodeAt(offset))
        }
        const byteArray = new Uint8Array(byteArrays)
        //@ts-ignore
        const file = new File([byteArray], photo.name, { type: photo.type })
        return file
      })
      photoFiles.forEach((file) => {
        formData.append('photoIDs', file)
      })
      await AdminVoterService.updateIdentificationRegistration(voterId, formData)

      setDoClear(true)
      formik.resetForm()
      setDoClear(false)
      onClose()
      setTimeout(() => {
        onDone()
      }, 300)
    },
  })

  useEffect(() => {
    setHeaderLabel(t('Upload ID'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onCancel, variant: 'secondary' },
      { text: t('buttons.save'), onClick: formik.handleSubmit },
    ])
  }, [])

  const onCancel = () => {
    setDoClear(true)
    formik.resetForm()
    setDoClear(false)
    onClose()
  }

  useEffect(() => {
    setDoClear(true)
    formik.resetForm()
    setDoClear(false)
  }, [isOpen])

  return (
    <div>
      <UploadDocs
        formik={formik}
        setFieldValue={formik.setFieldValue}
        fileField1='proofOfIdentity'
        fileField2='supportedDocument'
        req={true}
        acceptedFilesLink={''}
        onClear={doClear}
      />
    </div>
  )
}
